import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Buffer } from 'buffer';

import {
    Box,
    Button,
    Grid,
    TextField
} from '@mui/material';

import { fetchOrganizationExport } from '@/api/organizations';
import { fetchOrganizationQueryOptions } from '@/api/organizationsQueryOptions';
import { fetchDetailPermissionsQueryOptions } from '@/api/permissionsQueryOptions';
import LoadProgress from '@/components/LoadProgress';
import { exportBlob } from '@/lib/exportUtils';
import { DateField } from '@mui/x-date-pickers';
import { useFlag } from '@unleash/proxy-client-react';
import dayjs from 'dayjs';
import { t } from 'i18next';

export const Route = createFileRoute(
    '/_auth/organization_/$organizationUuid/info',
)({
    component: OrganizationComponent,
})

function OrganizationComponent() {
    const params = Route.useParams()
    const organizationQuery = useSuspenseQuery(fetchOrganizationQueryOptions(params.organizationUuid))
    const organization = organizationQuery.data

    const exportFlag = useFlag('export')

    const permissionsQuery = useSuspenseQuery(fetchDetailPermissionsQueryOptions('organization', params.organizationUuid, ['export']))
    const permissions = permissionsQuery.data

    if (organizationQuery.isLoading || organizationQuery.isFetching) {
        return <LoadProgress />
    }
    if (permissionsQuery.isLoading || permissionsQuery.isFetching) {
        return <LoadProgress />
    }

    const exportCondition = exportFlag && permissions && permissions.filter(p => p.detail === 'export' && p.permissions.some(a => a === 'read')).length > 0

    return (
        (<>
            <Grid container spacing={1}>
                <Grid
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 4
                    }}>
                    <Box>
                        <DateField
                            defaultValue={
                                organization.createDate ? dayjs(organization.createDate) : undefined
                            }
                            slotProps={{ textField: { readOnly: true, variant: "standard" } }}
                            label={t('property.general.createDate')}
                        />
                        <TextField
                            defaultValue={organization.createdBy}
                            slotProps={{ htmlInput: { readOnly: true } }}
                            label={t('property.general.createdBy')}
                        />
                        <DateField
                            defaultValue={
                                organization.updateDate ? dayjs(organization.updateDate) : undefined
                            }
                            slotProps={{ textField: { readOnly: true, variant: "standard" } }}
                            label={t('property.general.updateDate')}
                        />
                        <TextField
                            defaultValue={organization.updatedBy}
                            slotProps={{ htmlInput: { readOnly: true } }}
                            label={t('property.general.updatedBy')}
                        />

                    </Box>
                </Grid>
            </Grid>

            <Grid container spacing={1} sx={{ marginTop: 2 }}>
                <Grid
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 4
                    }}>
                    {exportCondition &&
                        <Button variant="contained" onClick={() => {
                            fetchOrganizationExport(params.organizationUuid).then((response) => {
                                const base64 = response.base64 || ''
                                // console.log(base64)
                                const raw = Buffer.from(base64, 'base64')
                                // console.log(raw)
                                const blob = new Blob([raw], {
                                    type: 'application/json',
                                });
                                exportBlob(blob, response.filename || 'export.json');
                            })
                        }}>
                            Vollexport
                        </Button>
                    }
                </Grid>
            </Grid>

        </>)
    );
}
